import React from 'react';
import ModalCloseIcon from '@/components/general/ModalCloseIcon/ModalCloseIcon';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const AgendaCitaModal = ({
  open,
  onClose,
  onSelectDaniel,
  onAgreeButton,
  patientsxUser,
  setPatientInformation,
  patientDataFromLocalStorage,
  isLoadingPatientsxUser,
}) => {
  const paciente = JSON.parse(localStorage.getItem('user')) || {};

  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-items-center"
      style={{
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
      }}
    >
      <FlexContainer
        className="pos-rel width-700px height-380px padtb26 padlr36 m-padlr0 m-marglr10"
        style={{
          background: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0px 5px 18px rgba(0,0,0,0.18)',
        }}
      >
        {/* BOTÓN CERRAR */}
        <FlexContainer
          onClick={onClose}
          className="pos-abs top15 right16 pointer width-28px height-28px align-items-center justify-center text-18 fontWhite"
          style={{
            borderRadius: '50%',
            background: '#023B7A',
            fontWeight: 900,
            boxShadow: '0px 2px 5px rgba(2, 59, 122, 0.3)',
            zIndex: 20,
          }}
        >
          <ModalCloseIcon />
        </FlexContainer>

        <div className="width100 height-300px bgWhite borderrad20 padtb20 padlr12 pos-rel top16">
          {/* HEADER */}
          <FlexContainer className="align-items-center gap-12 margb60 padtb0 padlr10">
            <FlexContainer
              className="align-items-center width-28px height-28px justify-center pointer"
              style={{
                borderRadius: '50%',
                border: '2px solid #6f8ec0',
              }}
            >
              <span
                className="text-18 lineHeight-1"
                style={{
                  color: '#6f8ec0',
                  fontWeight: 'bold',
                }}
              >
                ‹
              </span>
            </FlexContainer>

            <div className="text-16" style={{ fontWeight: 600 }}>
              <span style={{ color: '#023B7A' }}>
                <strong>Agenda una cita |</strong>
              </span>
              <span style={{ color: '#6f8ec0', fontWeight: 500 }}> ¿Para quién es la cita?</span>
            </div>
          </FlexContainer>

          {isLoadingPatientsxUser && (
            <>
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  background: 'rgba(255,255,255,0.7)',
                  zIndex: 10,
                  borderRadius: '10px',
                }}
              >
                <div className="spinner" />
              </div>
            </>
          )}
          {!isLoadingPatientsxUser && (
            <FlexContainer
              className="align-items-center justify-center gap-20"
              style={{
                marginTop: '12px',
                marginLeft: '28px',
                paddingRight: '28px',
                flexWrap: 'nowrap',
                overflowX: 'auto',
                overflowY: 'hidden',
              }}
            >
              <FlexContainer
                className="flex-column align-center pointer"
                style={{ flex: '0 0 auto' }}
                onClick={() => {
                  setPatientInformation(patientDataFromLocalStorage);
                  onSelectDaniel();
                }}
              >
                <FlexContainer
                  className="width-100px height-100px justify-center align-items-center"
                  style={{
                    borderRadius: '50%',
                    background: '#023B7A',
                    marginBottom: '8px',
                  }}
                >
                  <i className="fas fa-user text-30 fontWhite" />
                </FlexContainer>
                <FlexContainer className={'flex-column'}>
                  <Label
                    className="text-13 font-semibold"
                    style={{ color: '#374151', textAlign: 'center' }}
                  >
                    {paciente.name}
                  </Label>
                  <Label
                    className="text-13 font-semibold"
                    style={{ color: '#374151', textAlign: 'center' }}
                  >
                    {paciente.paterno || ''} (Yo)
                  </Label>
                </FlexContainer>
              </FlexContainer>

              {patientsxUser.map((p) => (
                <FlexContainer
                  key={p.id}
                  className="flex-column align-center pointer"
                  style={{ flex: '0 0 auto' }}
                  onClick={() => {
                    setPatientInformation(p);
                    onSelectDaniel();
                  }}
                >
                  <FlexContainer
                    className="width-100px height-100px justify-center align-items-center"
                    style={{
                      borderRadius: '50%',
                      background: '#023B7A',
                      marginBottom: '8px',
                    }}
                  >
                    <i className="fas fa-user text-30 fontWhite" />
                  </FlexContainer>
                  <FlexContainer className={'flex-column'}>
                    <Label
                      className="text-13 font-semibold"
                      style={{ color: '#374151', textAlign: 'center' }}
                    >
                      {p.nombres}
                    </Label>
                    <Label
                      className="text-13 font-semibold"
                      style={{ color: '#374151', textAlign: 'center' }}
                    >
                      {p.apellido_paterno}
                    </Label>
                  </FlexContainer>
                </FlexContainer>
              ))}

              <FlexContainer
                className="flex-column align-center pointer"
                style={{ flex: '0 0 auto' }}
                onClick={onAgreeButton}
              >
                <FlexContainer
                  className="width-100px height-100px justify-center align-items-center bgWhite"
                  style={{
                    borderRadius: '50%',
                    border: '2.5px solid #6f8ec0',
                    marginBottom: '8px',
                  }}
                >
                  <i className="fas fa-plus text-30" style={{ color: '#6f8ec0' }} />
                </FlexContainer>
                <FlexContainer className={'flex-column'}>
                  <Label
                    className="text-13 font-semibold"
                    style={{ color: '#6f8ec0', textAlign: 'center' }}
                  >
                    Agregar
                  </Label>
                  <Label
                    className="text-13 font-semibold"
                    style={{ color: '#6f8ec0', textAlign: 'center' }}
                  >
                    familiar
                  </Label>
                </FlexContainer>
              </FlexContainer>
            </FlexContainer>
          )}
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default AgendaCitaModal;
